export default __webpack_public_path__ + "static/media/image-white.16cfa205.svg";